import { detect } from 'detect-browser';

const { os, name, version } = detect() || {};

const MIN_SAFARI_VERSION_WITH_SCREEN_SHARE = 14;
const MIN_SAFARI_VERSION_WITH_MEDIA_RECORDING = 15;
const MIN_SAFARI_VERSION_WITH_OFFSCREENCANVAS = 16;

const SUPPORTED_BROWSERS = {
  iOS: ['ios'],
  'Android OS': ['chrome'],
  Windows: ['chrome', 'firefox', 'edge', 'edge-chromium'],
  Linux: ['chrome', 'firefox'],
  'Mac OS': ['chrome', 'firefox', 'edge', 'edge-chromium', 'safari']
};

const browserNotSupported = () => {
  if (!os || !name) {
    return false;
  }

  const isUCBrowser = navigator.userAgent.includes(' UCBrowser/');

  if (os === 'Android OS' && isUCBrowser) {
    return true;
  }

  const operatingSystem = os.includes('Windows') ? 'Windows' : os;
  const supportedBrowsers = SUPPORTED_BROWSERS[operatingSystem];

  return supportedBrowsers ? !supportedBrowsers.includes(name) : false;
};

const isMobile = () => (
  os === 'Android OS'
  || os === 'iOS'
  || os === 'BlackBerry OS'
  || os === 'Windows Mobile'
);

const browserMajorVersion = () => version.split('.')[0];

const isChromeBrowser = () => name === 'chrome';

const isFirefoxBrowser = () => name === 'firefox';

const isSafariMobile = () => name === 'ios';

const isSafariDesktop = () => name === 'safari';

const isIOS = () => os === 'iOS';

const isSafariScreenShareSupported = () => parseInt(browserMajorVersion(), 10) >= MIN_SAFARI_VERSION_WITH_SCREEN_SHARE;

const isSafariRecordSupported = () => parseInt(browserMajorVersion(), 10) >= MIN_SAFARI_VERSION_WITH_MEDIA_RECORDING;

const safariOffscreenCanvas = () => parseInt(browserMajorVersion(), 10) >= MIN_SAFARI_VERSION_WITH_OFFSCREENCANVAS;

const isIpad = () => {
  const { userAgent } = navigator;

  if (/iPad/i.test(userAgent)) {
    return true;
  }

  return /Macintosh/i.test(userAgent) && navigator.maxTouchPoints >= 1;
};

export {
  safariOffscreenCanvas,
  browserNotSupported,
  isMobile,
  isChromeBrowser,
  isFirefoxBrowser,
  isSafariMobile,
  isSafariDesktop,
  browserMajorVersion,
  isSafariScreenShareSupported,
  isSafariRecordSupported,
  isIpad,
  isIOS
};
